import { IAuctionServiceCost } from '../../../../../redux/reducers';
import { IAuctionServiceCostSchema } from '../../internalTypes';
import { getServiceId } from '../getServiceId';

export function mapAuctionServiceCosts(serviceCosts?: IAuctionServiceCostSchema[] | null): IAuctionServiceCost[] {
  if (!serviceCosts) {
    return [];
  }

  return serviceCosts.map(serviceCost => {
    const { serviceTypes, cost } = serviceCost;

    const serviceId = getServiceId({ services: serviceTypes });

    return {
      serviceId,
      serviceTypes,
      cost: Number(cost),
    };
  });
}
